// Auto-generated by scripts/import_haydock.py — edit with care.
const chapter = {
  book: "Psalms",
  bookSlug: "psalms",
  chapter: 120,
  argument: "God is the keeper of his servants.",
  verses: [
    { n: 1, text: "A gradual canticle. I have lifted up my eyes to the mountains, from whence help shall come to me." },
    { n: 2, text: "My help is from the Lord, who made heaven and earth." },
    { n: 3, text: "May he not suffer thy foot to be moved: neither let him slumber that keepeth thee." },
    { n: 4, text: "Behold he shall neither slumber nor sleep, that keepeth Israel." },
    { n: 5, text: "The Lord is thy keeper, the Lord is thy protection, upon thy right hand." },
    { n: 6, text: "The sun shall not burn thee by day, nor the moon by night." },
    { n: 7, text: "The Lord keepeth thee from all evil: may the Lord keep thy soul." },
    { n: 8, text: "May the Lord keep thy coming in and thy going out; from henceforth now and for ever." },
  ],
  commentary: [
    { verse: 1, notes: [
      { text: "Canticle. David wrote this during his flight from Absalom; (Grotius) and de Muis judges from the martial air, that it was composed in the midst of danger. It relates to the captives, (Origen; Calmet) and to all in the pilgrimage of this world. (Berthier) — Mountains. Jerusalem, and heaven, whence all our help must come. God most readily hears the prayers which are poured forth in places appointed by him. (Worthington) — Jerusalem was situated among mountains, and the Jews turned towards it in prayer, Daniel vi. 10. They did not depend on human aid, Jeremias iii. 22.", attribution: "Haydock" }
    ] },
    { verse: 3, notes: [
      { text: "May. Hebrew, \"he will not.\" Many have read in the second person, both in the Hebrew and Septuagint, \"Suffer not thy,\" &c. (Aquila; St. Augustine, &c.)", attribution: "Calmet" }
    ] },
    { verse: 4, notes: [
      { text: "Israel. The Church militant. (Worthington) — These figurative expressions shew that God will never cease to protect his people.", attribution: "Berthier" }
    ] },
    { verse: 5, notes: [
      { text: "Hand. Always ready, Psalm xc. 4., and xv. 8.", attribution: "Haydock" }
    ] },
    { verse: 6, notes: [
      { text: "Night. Neither prosperity nor adversity shall hurt thee, (St. Jerome) or the Church. (Worthington) — Cold is said to burn or parch up, Genesis xxxi. 40. Justin (2) writes of the Scythians, Quanquam continuis frigoribus urantur, as the effects of extreme heat and cold are similar. The Jews were protected from both at their return; (Isaias iv. 6., and xlix. 10.; Calmet) though we may doubt of this explanation, as the text is applied to those in heaven, Apocalypse vii. 16.", attribution: "Berthier" }
    ] },
    { verse: 7, notes: [
      { text: "Keepeth. Hebrew also, \"shall or may.\" The words of a prophet are always true, and the tenses are varied at pleasure by St. Jerome, &c. (Berthier) — Soul, or spiritual life. (Worthington)", attribution: "1 Peter i. 4." }
    ] },
    { verse: 8, notes: [
      { text: "Coming in. Hebrew has, \"going out,\" first. (Berthier) — Yet Pagnin agrees with us. (Haydock) — This expression denotes all the occurrences of life, Deuteronomy xxviii. 6. (Calmet) — We may discover a beautiful progression in this psalm; God protects us from each and from every danger. (Berthier) — He is not like earthly friends, who have not always the will or the power to do it.", attribution: "St. Chrysostom" }
    ] },
  ],
};

export default chapter;
